<div class="product-promotion-container" *ngIf="promotions.ProductLevelPromotion" >
	<common-side-nav class="common-side-nav" [side]="'right'" [addFlexBox]="addFlexBox" [isSidePanelToggled]="isSidePanelToggled" [modalName]="heading" *ngFor="let key of promotions | keys; trackBy: trackByFn;" tabindex="0" (panelEvent)="panelOpened($event)">
		<div id="promoPanelHeader" ngProjectAs="myCustomHeader">
			{{ heading }}
		</div>
		<div id="promoPanelBody" ngProjectAs="myCustomBody" [innerHTML]="promotions[key?.key]?.longDesc | dcsgSanitizeHtml"></div>
		<div class="promotion-description-text-container hmf-mb-xs hmf-mb-m-s" ngProjectAs="myPanelCover" >
			<a class="promotion-description-text hmf-subheader-m" href="javascript:void(0)">{{ key?.value?.pdpDesc }}</a>
		</div>
	</common-side-nav>
</div>
<div class="product-promotion-container" *ngIf="displayPromotion">
	<common-side-nav class="common-side-nav" [side]="'right'" [isSidePanelToggled]="isSidePanelToggled" [modalName]="heading" tabindex="0">
		<div id="promoPanelHeader" ngProjectAs="myCustomHeader">
			{{ heading }}
		</div>
		<div id="promoPanelBody" ngProjectAs="myCustomBody" [innerHTML]="displayPromotion.longDesc | dcsgSanitizeHtml"></div>
		<div class="promotion-description-text-container hmf-mb-xs hmf-mb-m-s" ngProjectAs="myPanelCover" >
			<a class="promotion-description-text hmf-subheader-m" href="javascript:void(0)">{{ displayPromotion.pdpDesc }}</a>
		</div>
	</common-side-nav>
</div>
